import { createCullableNode } from '../utils/createCullableNode.mjs';
import { getInternalRouter } from '../utils/getInternalRouter.mjs';

/**
 * Call a custom action on routing. The action will be called on every render.
 * @usage ./Action.usage.md
 */
const Action = ({ action }, _, utils) => createCullableNode(getInternalRouter().action(action), utils);

export { Action };
